<div class="row">
  <div class="col-xs-12 col-md-4">
    <app-menudesktop (contratoenvio)="recibirContrato($event)"></app-menudesktop>
  </div>

  <div class="col-xs-12 col-md-8">
    <alertbox
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    ></alertbox>
    <h1>Consumo y facturas</h1>
    <div class="row">
      <label><b>Dirección suministro</b> {{direccionSuministro}}</label>
    </div>
    <div class="row scyr-no-avisos">

      <section class="col-xs-12 col-sm-6 col-md-6 scyr-section">
        <div
          *ngIf="existenFacturas"
          class="scyr-ultima-factura box"
        >
          <h2>Su última factura</h2>
          <div class="scyr-ultima-factura-items">
            <div class="scyr-dato total">
              <p class="scyr-dato__xl">{{total | currency: 'EUR'}}
              </p>
              <p class="">Total a pagar</p>
            </div>
            <div
              *ngIf="fechalectura!==undefined"
              class="scyr-dato consumo"
            >
              <p class="scyr-dato__xl">{{consumo}}
                <span>m
                  <sup>3</sup>
                </span>
              </p>
              <p>Consumo</p>
            </div>
            <div
              *ngIf="fechalectura===undefined"
              class="scyr-dato consumo"
            >
              <p
                class="scyr-dato__xl"
                *ngIf="cobrada"
              >Pagado</p>
              <p
                class="scyr-dato__xl"
                *ngIf="!cobrada"
              >Pendiente</p>
              <p>Estado</p>
            </div>
            <div class="scyr-dato periodo">
              <p class="scyr-dato__sm">Período</p>
              <p class="fecha">{{periodo}}</p>
            </div>
            <div
              *ngIf="fechalectura!==undefined"
              class="scyr-dato fecha"
            >
              <p class="scyr-dato__sm">Fecha lectura</p>
              <p class="fecha">
                {{fechalectura | date:'dd-MM-yyyy'}}
              </p>
            </div>
            <div
              *ngIf="fechalectura===undefined"
              class="scyr-dato fecha"
            >
              <p class="scyr-dato__sm">Fecha factura</p>
              <p class="fecha">
                {{fechaFactura | date:'dd-MM-yyyy'}}
              </p>
            </div>
            <span class="white-block"></span>
          </div>
          <div>
            <div class="scyr-ultima-factura-btn">
              <button
                type="button"
                (click)="onDescargarFactura()"
                class="btn-default"
              >Descargar Factura</button>
            </div>
          </div>
        </div>
      </section>

      <section class="col-xs-12 col-sm-6 col-md-6 scyr-section">
        <div
          *ngIf="existenFacturas"
          class="scyr-grafico"
        >
          <div class="title-area">
            <h2>Evolución de su consumo</h2>
          </div>
          <div
            id="chart_div"
            class="chart"
          >
            <bar-chart-demo [grafica]="facturas"></bar-chart-demo>
          </div>
        </div>
      </section>

    </div>

    <div class="row">
      <section class="col-xs-12">

        <div
          class="scy-table"
          *ngIf="isAuthenicated && existenFacturas"
        >
          <div
            id="tabla-facturas_wrapper"
            class="dataTables_wrapper no-footer"
          >

            <ng-container *ngIf="isMobile; else elseTemplate">

              <div
                class="table-detail-expanded"
                *ngFor="let row of rows"
              >

                <div class="row with-background">
                  <label class="row-detail-flex-title">Período</label>
                  <div class="row-detail-flex-data">
                    {{ getRowItem(row).Periodo.Descripcion }}
                  </div>
                </div>

                <div class="row with-background">
                  <label class="row-detail-flex-title">Fecha factura</label>
                  <div class="row-detail-flex-data">
                    {{ getRowItem(row).Fecha | date:'dd-MM-yyyy' }}
                  </div>
                </div>

                <div class="row">
                  <label class="row-detail-flex-title">Fecha lectura</label>
                  <div class="row-detail-flex-data">
                    {{ getRowItem(row).FechaLecturaFactura | date:'dd-MM-yyyy' }}
                  </div>
                </div>

                <div class="row">
                  <label class="row-detail-flex-title">Consumo</label>
                  <div class="row-detail-flex-data">
                    {{ getRowItem(row).ConsumoFactura }} m<sup>3</sup>
                  </div>
                </div>

                <div class="row">
                  <label class="row-detail-flex-title">Importe</label>
                  <div class="row-detail-flex-data">
                    {{ getRowItem(row).TotalFacturado }} €
                  </div>
                </div>

                <div class="row">
                  <label class="row-detail-flex-title">Factura</label>
                  <div class="row-detail-flex-data">

                    <a
                      class="table-cell-img-text"
                      (click)="onDescargarFactura(getRowItem(row))"
                    >
                      <img
                        class="descarga-mobile"
                        src="./assets/images/icons/factura.svg"
                        alt="Descargar factura en pdf"
                      >
                      <span class="descarga-desktop">Descargar</span>
                    </a>

                  </div>
                </div>

                <div class="row">
                  <label class="row-detail-flex-title">Estado</label>
                  <div class="row-detail-flex-data">
                    <span
                      class="table-cell-img-text"
                      [ngClass]="{
                            'green': getRowItem(row).Cobrada,
                            'red': !getRowItem(row).Cobrada
                          }"
                      (click)="SeleccionarFacturaTablaPasarela(getRowItem(row))"
                    >
                      <img
                        [src]="getRowItem(row).Cobrada 
                            ? './assets/images/icons/tick-verde.svg'
                            : './assets/images/icons/averia-rojo.svg'"
                        title="'Estado'"
                        [alt]="'Estado'"
                      >{{ getEstadoTexto(row) }}
                    </span>
                  </div>
                </div>

              </div>

            </ng-container>
            <ng-template #elseTemplate>

              <!-- NGX-DATATABLE -->

              <ngx-datatable
                #myTable
                class="material min-width"
                [ngClass]="{'fullscreen': _tableFullscreen}"
                [columnMode]="_columnMode"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="50"
                [scrollbarV]="true"
                [rows]="rows"
              >
                <ngx-datatable-column
                  name="PeriodoCodigo"
                  [flexGrow]="1"
                  [minWidth]="_minWidth"
                  [maxWidth]="100"
                  [sortable]="false"
                >
                  <ng-template ngx-datatable-header-template>
                    <span (click)="onSortArray('PeriodoCodigo')">Período
                      <span
                        *ngIf="showSortIcon('PeriodoCodigo')"
                        class="table-header-sort"
                        [ngClass]="{'down': !ascendingOrder, 'up':ascendingOrder}"
                      >&gt;</span>
                    </span>
                  </ng-template>

                  <ng-template
                    let-row="row"
                    let-value="value"
                    ngx-datatable-cell-template
                  >
                    {{ getRowItem(row).Periodo.Descripcion }}
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="Fecha"
                  [flexGrow]="1"
                  [minWidth]="_minWidth"
                  [maxWidth]="120"
                  [sortable]="false"
                >
                  <ng-template ngx-datatable-header-template>
                    <span
                      (click)="onSortArray('Fecha')"
                      class="mobile-hidden"
                    >Fecha factura
                      <span
                        *ngIf="showSortIcon('Fecha')"
                        class="table-header-sort"
                        [ngClass]="{'down': !ascendingOrder, 'up':ascendingOrder}"
                      >&gt;</span>
                    </span>
                    <span class="desktop-hidden"></span>
                  </ng-template>

                  <ng-template
                    let-row="row"
                    let-value="value"
                    ngx-datatable-cell-template
                  >
                    <div [ngClass]="{'mobile-hidden': true}">
                      {{ getRowItem(row).Fecha | date:'dd-MM-yyyy' }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="FechaLecturaFactura"
                  [flexGrow]="1"
                  [minWidth]="_minWidth"
                  [maxWidth]="120"
                  [sortable]="false"
                >
                  <ng-template ngx-datatable-header-template>
                    <span
                      (click)="onSortArray('FechaLecturaFactura')"
                      class="mobile-hidden"
                    >Fecha lectura
                      <span
                        *ngIf="showSortIcon('FechaLecturaFactura')"
                        class="table-header-sort"
                        [ngClass]="{'down': !ascendingOrder, 'up':ascendingOrder}"
                      >&gt;</span>
                    </span>
                    <span class="desktop-hidden"></span>
                  </ng-template>

                  <ng-template
                    let-row="row"
                    let-value="value"
                    ngx-datatable-cell-template
                  >
                    <div [ngClass]="{'mobile-hidden': true}">
                      {{ getRowItem(row).FechaLecturaFactura | date:'dd-MM-yyyy' }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="ConsumoFactura"
                  [flexGrow]="1"
                  [minWidth]="_minWidth"
                  [maxWidth]="100"
                  [sortable]="false"
                >
                  <ng-template ngx-datatable-header-template>
                    <span
                      (click)="onSortArray('ConsumoFactura')"
                      class="mobile-hidden"
                    >Consumo
                      <span
                        *ngIf="showSortIcon('ConsumoFactura')"
                        class="table-header-sort"
                        [ngClass]="{'down': !ascendingOrder, 'up':ascendingOrder}"
                      >&gt;</span>
                    </span>
                    <span class="desktop-hidden"></span>
                  </ng-template>

                  <ng-template
                    let-row="row"
                    let-value="value"
                    ngx-datatable-cell-template
                  >
                    <div
                      [ngClass]="{'mobile-hidden': true}"
                      *ngIf="getRowItem(row).FechaLecturaFactura !== null"
                    >
                      {{ getRowItem(row).ConsumoFactura }}m<sup>3</sup>
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="TotalFacturado"
                  [flexGrow]="1"
                  [minWidth]="_minWidth"
                  [maxWidth]="100"
                  [sortable]="false"
                >
                  <ng-template ngx-datatable-header-template>
                    <span
                      (click)="onSortArray('TotalFacturado')"
                      class="mobile-hidden"
                    >Importe
                      <span
                        *ngIf="showSortIcon('TotalFacturado')"
                        class="table-header-sort"
                        [ngClass]="{'down': !ascendingOrder, 'up':ascendingOrder}"
                      >&gt;</span>
                    </span>
                    <span class="desktop-hidden"></span>
                  </ng-template>

                  <ng-template
                    let-row="row"
                    let-value="value"
                    ngx-datatable-cell-template
                  >
                    <div [ngClass]="{'mobile-hidden': true}">
                      {{ getRowItem(row).TotalFacturado }} €
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="Factura"
                  [flexGrow]="1"
                  [minWidth]="_minWidth"
                  [maxWidth]="100"
                  [sortable]="false"
                >
                  <ng-template ngx-datatable-header-template>
                    <span class="mobile-hidden not-sortable">Factura</span>
                    <span class="desktop-hidden"></span>
                    <span
                      *ngIf="showSortIcon('Factura')"
                      class="table-header-sort"
                      [ngClass]="{'down': !ascendingOrder, 'up':ascendingOrder}"
                    >&gt;</span>
                  </ng-template>

                  <ng-template
                    let-row="row"
                    let-value="value"
                    ngx-datatable-cell-template
                  >
                    <div [ngClass]="{'mobile-hidden': true}">

                      <div class="pdf">
                        <a
                          class="table-cell-img-text"
                          (click)="onDescargarFactura(getRowItem(row))"
                        >
                          <img
                            class="descarga-mobile"
                            src="./assets/images/icons/factura.svg"
                            alt="Descargar factura en pdf"
                          >
                          <span
                            class="descarga-desktop auto-fade"
                            [ngClass]="{'hide': isMobile}"
                          >Descargar</span>
                        </a>
                      </div>

                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                  name="Cobrada"
                  [flexGrow]="1"
                  [minWidth]="_minWidth"
                  [maxWidth]="100"
                  [sortable]="false"
                >
                  <ng-template ngx-datatable-header-template>
                    <span
                      (click)="onSortArray('Cobrada')"
                      class="mobile-hidden"
                    >Estado
                      <span
                        *ngIf="showSortIcon('Cobrada')"
                        class="table-header-sort"
                        [ngClass]="{'down': !ascendingOrder, 'up':ascendingOrder}"
                      >&gt;</span>
                    </span>
                    <span class="desktop-hidden"></span>
                  </ng-template>

                  <ng-template
                    let-row="row"
                    let-value="value"
                    ngx-datatable-cell-template
                  >
                    <div [ngClass]="{'mobile-hidden': true}">
                      <a
                        class="table-cell-img-text"
                        [ngClass]="{
                        'green': getRowItem(row).Cobrada,
                        'red': !getRowItem(row).Cobrada
                      }"
                        (click)="SeleccionarFacturaTablaPasarela(getRowItem(row))"
                      >
                        <img
                          class="descarga-mobile"
                          [src]="getRowItem(row).Cobrada 
                        ? './assets/images/icons/tick-verde.svg'
                        : './assets/images/icons/averia-rojo.svg'"
                          title="'Estado'"
                          [alt]="'Estado'"
                        >
                        <span>{{ getEstadoTexto(row) }}</span>
                      </a>
                    </div>
                  </ng-template>
                </ngx-datatable-column>

              </ngx-datatable>

            </ng-template>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<!-- MODAL -->
<sacyr-modal
  [setTemplateRef]="modal_content"
  [showModal]="_showModalFactura || _showModalPasarela"
  (closeModal)="closeModal()"
></sacyr-modal>

<ng-template #modal_content>

  <ng-container *ngIf="_showModalFactura">
    <div id="modal_factura">
      <h2>¿Aún no recibe la factura electrónica?</h2>
      <div class="modal-factura__texto">
        <div class="modal-img col-xs-6">
          <img
            class="big"
            src="assets/images/icons/icono-modal.svg"
            alt=""
          >
        </div>
        <ul class="col-xs-6">
          <li>SIN PAPEL</li>
          <li>No se pierde</li>
          <li>Siempre disponible</li>
          <li>¡Una ayuda adicional si tienes inquilinos!</li>
        </ul>
      </div>
      <div class="modal-factura__button">
        <a (click)="DescargarFactura()">Descargar Factura</a>
        <button
          (click)="subscribirFacturaElectronica()"
          type="button"
          class="btn-default"
          data-dismiss="modal"
        >subscríbase</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="_showModalPasarela">
    <div id="modal_pasarela">
      <h3>¿Desea pagar su factura con importe <span>{{(FacturaPasarela.TotalFacturado /100) | currency:
          'EUR'}}</span>?</h3>
      <p></p>
      <div class="modal-factura__button">
        <a
          href="{{this.TPVpage}}?explotacion={{this.Explotacion}}&importe={{FacturaPasarela.TotalFacturado}}&facCod={{FacturaPasarela.FacturaCodigo}}&facCtr={{FacturaPasarela.ContratoCodigo}}&facVersion={{FacturaPasarela.Version}}&facPeriodo={{FacturaPasarela.PeriodoCodigo}}">
          Clic para redireccionar a la pasarela de pago</a>
      </div>
    </div>
  </ng-container>

</ng-template>
